<template>
  <div class="container">
    <div class="product">
      <div class="product-flex">
        <div class="search-box">
          <a-input-group compact>
            <a-select v-model:value="queryBy"
                      class="option-select"
                      :options="queryByOptions"> </a-select>
            <a-input v-if="queryBy === 'name'"
                     v-model:value="query.name"
                     :placeholder="$t('material.Material.queryName')"
                     style="width: 60%" />
            <a-select v-if="queryBy === 'tag'"
                      v-model:value='query.tag'
                      mode="multiple"
                      max-tag-count="responsive"
                      style="width: 60%"
                      :placeholder="$t('material.Material.queryTag')"
                      :options="materialTag">
            </a-select>
          </a-input-group>
        </div>
        <div>
          <a-button type="primary"
                    class="m10"
                    @click="onSearch">
            <search-outlined />{{ $t('material.Material.onSearch') }}
          </a-button>
          <a-button class="m10"
                    @click="addMaterial">
            <plus-square-outlined />{{ $t('material.Material.addMaterial') }}
          </a-button>
          <a-button class="danger-btn"
                    @click="deleteAllMaterial">
            <delete-outlined />{{ $t('material.Material.delete') }}
          </a-button>
        </div>
      </div>
      <div class="table">
        <a-scroll-table class="scroll"
                        :row-selection="rowSelection"
                        :columns="MATERIAL_COLUMNS"
                        :data-source="materialItems"
                        :pagination="false"
                        row-key="id">
          <template #bodyCell="{ record, column }">
            <template v-if="column.dataIndex === 'image'">
              <a-popover placement="right">
                <template #content>
                  <img :src="toUrl(record.image)"
                       alt=""
                       class="pop-image">
                </template>
                <img :src="toUrl(record.image)"
                     alt="">
              </a-popover>

            </template>
            <template v-if="column.dataIndex === 'tag'">
              <span v-for="item in materialTag"
                    :key="item.id">
                <span v-for="(tag, index) in record.tag?.split(',')"
                      :key="index">
                  {{ tag == item.value ? item.label + ' ' : '' }}
                </span>
              </span>
            </template>
            <template v-if="column.dataIndex === 'time'">
              <div>{{ $t('material.Material.create') }}：{{ convertTime(record.createdAt) }}</div>
              <div>{{ $t('material.Material.update') }}：{{ convertTime(record.updatedAt) }}</div>
            </template>
            <template v-if="column.dataIndex === 'operation'">
              <a-tooltip placement="bottom"
                         :color="'#111'">
                <template #title>
                  <span>{{ $t('material.Material.edit') }}</span>
                </template>
                <FormOutlined class="operation-icon m20"
                              @click="editMaterial(record)" />
              </a-tooltip>
              <a-tooltip placement="bottom"
                         :color="'#111'">
                <template #title>
                  <span>{{ $t('material.Material.delete') }}</span>
                </template>
                <DeleteOutlined class="operation-icon"
                                @click="deleteMaterial(record)" />
              </a-tooltip>
            </template>
          </template>
        </a-scroll-table>
        <div class="footer">
          <div style="display: flex; justify-content: flex-end">
            <APagination v-model:current="pagination.page"
                         v-model:pageSize="pagination.limit"
                         :total="pagination.total"
                         @change="onChange" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 添加图片modal-->
  <a-modal v-model:visible="materialModalState"
           :title="materialState == 'add' ? $t('material.Material.addImage') : $t('material.Material.editImage')"
           @ok="materialModalConfirm"
           @cancel="resetModal">
    <a-form ref="materialFormRef"
            :model="materialForm"
            :label-col="{ span: 6 }">
      <a-form-item :label="$t('material.Material.selectImage')"
                   name="image"
                   :rules="[{ required: true, message: $t('material.Material.selectImageTip') }]">
        <a-upload v-model:file-list="fileList"
                  list-type="picture-card"
                  :with-credentials="true"
                  :action="toUrl('/v1/api/attachment/material')"
                  :before-upload="verifyUploadImgName"
                  @remove="handleRemove"
                  @preview="handlePreview"
                  @change="handleUpload">
          <div>
            <plus-outlined />
            <div style="margin-top: 8px">{{ $t('material.Material.upload') }}</div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item :label="$t('material.Material.imageName')"
                   name="name"
                   :rules="[{ required: true, message: $t('material.Material.imageNameTip') }]">
        <a-input v-model:value="materialForm.name"
                 :placeholder="$t('material.Material.imageNameTip')"
                 @pressEnter="materialModalConfirm"></a-input>
      </a-form-item>
      <a-form-item :label="$t('material.Material.selectTag')"
                   name="tag"
                   :rules="[{ required: true, message: $t('material.Material.selectTagTip') }]">
        <!-- <a-select v-model:value='materialForm.tag'
                  mode="multiple"
                  style="width: 100%"
                  placeholder="请选择图片标签"
                  :options="materialTag">
        </a-select> -->
        <div class="image-content-tagbox">
          <div v-for="item in materialTag"
               :key="item.value"
               class="image-content-tag"
               :class="materialForm.tag?.includes(item.value) ? 'selected-tag' : ''"
               @click="selectTag(item)">
            {{ item.label }}
            <div v-show="materialForm.tag?.includes(item.value)"
                 class="tag-icon"></div>
          </div>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
  <a-modal :visible="previewVisible"
           :title="previewTitle"
           :footer="null"
           @cancel="handleCancelPreview">
    <img alt="Preview"
         style="width: 100%"
         :src="previewImage" />
  </a-modal>
</template>

<script setup lang="ts">
import { toUrl, verifyUploadImgName } from "@/utils"
import { AScrollTable, APagination } from '@iota-cn/ui-components'
import { message, Modal, type UploadChangeParam, type TableProps } from 'ant-design-vue'
import { computed, onMounted, reactive, ref } from 'vue'
import { MATERIAL_COLUMNS } from '../api/interface/index'
import { addMateriaImage, editMateriaImage, deleteMateriaImage, getMaterialList } from '../api/index'
import { fetchMaterialTag } from '../../custom-spus/api/index'
import dayjs from "dayjs"
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const convertTime = (time: string): string => {
  return dayjs(time).format("YYYY-MM-DD HH:mm:ss")
}
// 分页
const pagination = reactive({
  total: 0,
  limit: 10,
  page: 1
})
const materialTag = ref<any[]>()
onMounted(async () => {
  await onSearch()
  materialTag.value = []
  await fetchMaterialTag().then((res) => {
    res.data.items.forEach((item: any) => {
      materialTag.value?.push({
        value: item.key,
        label: item.name
      })
    })
  })
})
// 输入框选择器
const queryBy = ref<string>("name")
const queryByOptions = computed(() => [
  {
    label: t('material.Material.name'),
    value: "name"
  },
  {
    label: t('material.Material.tag'),
    value: "tag"
  }
])
const selectTag = (item: any) => {
  if (materialForm.tag?.includes(item.value)) {
    materialForm.tag = materialForm.tag.filter((el: any) => el != item.value)
    // materialForm.tag = materialForm.tag
  } else {
    materialForm.tag.push(item.value)
  }
}
const query = reactive({
  tag: [],
  name: '',
})
const onSearch = () => {
  const condition = {
    limit: pagination.limit,
    offset: (pagination.page - 1) * pagination.limit,
  } as any
  if (queryBy.value === "name") {
    condition.name = query.name
  } else {
    condition.tag = query.tag.join(',')
  }
  getMaterialList(condition).then((result: any) => {
    materialItems.value = result.rows
    pagination.total = result.count
  })
}
const onChange = () => {

}
// 表格多选
const rowId = ref<number[]>([])
const rowSelection: TableProps["rowSelection"] = {
  onChange: (selectedRowKeys, selectedRows) => {
    rowId.value = []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectedRows.forEach((item: any) => {
      rowId.value.push(item.id)
    })
  }
}
const materialFormRef = ref()
const materialItems = ref<any>([])
const materialState = ref<'add' | 'edit'>('add')
const materialModalState = ref<boolean>(false)
const materialForm = reactive<any>({
  id: "",
  name: "",
  image: "",
  tag: []
})
const fileList = ref<any>([])

const addMaterial = () => {
  materialState.value = 'add'
  materialForm.id = ''
  materialForm.name = ''
  materialForm.tag = []
  materialForm.image = ''
  specifications.value = ''
  fileList.value = []
  materialModalState.value = true

}

const editMaterial = (item: any) => {
  materialForm.name = item.name
  materialForm.id = item.id
  materialForm.tag = item.tag ? item.tag.split(',') : []
  materialForm.image = item.image
  specifications.value = item.specification
  fileList.value = []
  fileList.value.push({
    url: toUrl(item.image)
  })
  materialState.value = 'edit'
  materialModalState.value = true
}

const deleteMaterial = (item: any) => {
  Modal.confirm({
    title: () => t('material.Material.confirmMsg'),
    onOk() {
      deleteMateriaImage({ ids: item.id }).then(() => {
        fileList.value = []
        message.success(t('material.Material.deleteImageSuccessful'))
        onSearch()
      })
    }
  })
}
const deleteAllMaterial = () => {
  if (rowId.value.length === 0) {
    message.warning(t('material.Material.selectMaterials'))
    return
  }
  Modal.confirm({
    title: () => t('material.Material.confirmSelectMsg'),
    onOk() {
      deleteMateriaImage({ ids: rowId.value.join() }).then(() => {
        fileList.value = []
        rowId.value = []
        message.success(t('material.Material.deleteImageSuccessful'))
        onSearch()
      })
    }
  })
}
const resetModal = () => {
  materialModalState.value = false
  materialFormRef.value?.resetFields()
}

const materialModalConfirm = () => {
  materialFormRef.value.validateFields().then(() => {
    const data = {
      name: materialForm.name,
      image: materialForm.image,
      tag: materialForm.tag.join(','),
      specifications: specifications.value
    }
    if (materialState.value == 'add') {
      addMateriaImage(data).then(() => {
        materialModalState.value = false
        message.success(t('material.Material.addImageSuccessful'))
        onSearch()
      }).catch(() => {
        message.error(t('material.Material.addImageFailed'))
      })
    } else {
      editMateriaImage(materialForm.id, data).then(() => {
        materialModalState.value = false
        message.success(t('material.Material.modifyImageSuccessful'))
        onSearch()
      }).catch(() => {
        message.error(t('material.Material.modifyImageFailed'))
      })
    }
  }).catch(() => {

  })
}

const previewVisible = ref(false)
const previewImage = ref('')
const previewTitle = ref('')

const handleCancelPreview = () => {
  previewVisible.value = false
  previewTitle.value = ''
}

const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string
  }
  previewImage.value = file.url || file.preview
  previewVisible.value = true
  previewTitle.value = ''
}
const specifications = ref<string>('')
const getImage = (url: string, file: any) => {
  const img = new Image()
  img.src = toUrl(url) as string
  img.onload = () => {
    const size = file.size ? (file.size / 1024).toFixed(2) : ''
    specifications.value = `${t('material.Material.width')}：${img.width}x${img.height} ${t('material.Material.type')}：${file.type} ${t('material.Material.size')}：${size}KB`
  }
}
const handleUpload = (info: UploadChangeParam) => {
  if (info.file.status === 'done') {
    materialForm.image = info.file.response.uploaded
    fileList.value = []
    fileList.value.push(info.file)
    getImage(info.file.response.uploaded, info.file)
  }
  if (info.file.status === 'error') {
    message.error(t('material.Material.uploadMsg'))
    fileList.value.splice(fileList.value.length - 1, 1)
  }
}

const handleRemove = () => {
  materialForm.image = ''
}

</script>

<style scoped lang="less">
.container {
  height: 100%;
  width: 100%;

  :deep(.ant-card-body) {
    flex: 1;
    overflow: auto;
    position: relative;
  }

  .category {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .material {
    height: 100%;
    display: flex;
    flex-direction: column;

    .items {
      flex: 1;

      .item {
        cursor: pointer;

        .title {
          padding-left: 20px;
        }

        &:hover {
          background-color: #eeeeee;
        }
      }

      .selected {
        background-color: #eeeeee;
      }

    }

    .nothings {
      background-color: #fff;
    }
  }

  .product {
    height: 100%;
    padding: 20px;

    .product-flex {
      display: flex;
      justify-content: space-between;
    }

    .search-box {
      width: 350px;

      .option-select {
        background: #f6f6f6;
      }

      :deep(.ant-select-selector) {
        height: 32px;
      }

      :deep(.ant-input) {
        height: 32px;
      }
    }

    .danger-btn {
      background: #de4a092b;
      color: #de4a09;
    }

    .m10 {
      margin-right: 10px;
    }

    .add {
      width: 200px;
    }

    .table {
      height: calc(100% - 32px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .scroll {
        flex: 1;
        margin-top: 20px;
        overflow: hidden;
      }

      .footer {
        margin-top: 20px;
      }

      img {
        width: 50px;
        // height: 10px;
      }

      .m20 {
        margin-right: 20px;
      }

      .operation-icon {
        color: #999;
      }

      .operation-icon:hover {
        color: #111;
      }
    }

    .title {
      line-height: 40px;
      background: hsl(0deg 0% 100% / 65%);
      backdrop-filter: blur(5px);
      text-align: center;
      color: black;
      font-size: 16px;
    }

    :deep(.ant-image) {
      margin: 15px;
    }

    .images {
      height: 85%;
      overflow: hidden;
      overflow-y: auto;
      background-color: #fff;
    }

    .nothings {
      display: flex;
      height: 85%;
      border-right: 1px solid #f0f0f0;
      background-color: #fff;

      .title {
        height: 70%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        line-height: 7vh;
        width: 100%;
        flex-direction: column;
      }
    }

    .buttonDiv {
      background: #fff;
      width: 100%;
      height: 7%;
      text-align: center;
    }
  }
}

.pop-image {
  width: 200px;
  height: 200px;
}

.image-content-tagbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;

  .selected-tag {
    border: 1px solid #111111;
  }

  .image-content-tag {
    position: relative;
    min-width: 68px;
    height: 24px;
    line-height: 24px;
    background: #F6F6F6;
    padding: 0 5px;
    font-size: 14px;
    text-align: center;
    margin: 0 15px 10px 0;
    cursor: pointer;

    .tag-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 18px;
      height: 18px;
      background: url('../../custom-spus/icon/ic_subscript.png');
    }
  }
}
</style>
